import { Suspense, lazy, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import "./SinglePost.scss";
// import TimeFormat from "../../components/TimeFormat/TimeFormat.js";
import { asideBoxes } from "../../shared/shared.js";
import BodyText from "../../components/BodyText/BodyText.js";
import AdManagerSlot from "../../components/AdvModule/AdManagerSlot.js";
import { formatTime2, id2, setSource, structuredData, urlTitle2 } from "../../shared/utillity.js";
import StickyAd from "../../components/AdvModule/StickyAd.js";
import { useGlobalLocation } from "../../shared/LocationContext.js";
import { useIdContext } from "../../shared/IdProvider.js";
import { useImageSize } from "react-image-size";
import PostImage from "./img/PostImage.js";
import { Helmet } from "react-helmet";

const SocialButtons = lazy(() => import("../../UI/SocialButtons/SocialButtons.js"));
const AsideBox = lazy(() => import("../../components/AsideBox/AsideBox.js"));

export default function SinglePost() {
  const { location, pathPart } = useGlobalLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const { post } = useIdContext();
  const displayTitle = post.title_2 || post.title;
  const memoAsideBoxes = useMemo(() => asideBoxes, []);
  const [dimensions, { loading, error }] = useImageSize(`${post.pics[0]}`);

  // const jsonLd = {
  //   "@context": "https://schema.org",
  //   "@type": "NewsArticle",
  //   headline: post.title_2 || post.title,
  //   description: post.lead || "",
  //   image: {
  //     "@type": "ImageObject",
  //     url: post.pics[0],
  //     width: dimensions?.width || 1200, // ako koristiš useImageSize
  //     height: dimensions?.height || 675,
  //   },

  //   datePublished: post.time2,
  //   dateModified: post.modified || post.time2,
  //   author: {
  //     "@type": "Person",
  //     name: (setSource(post.source) || "Redakcija").replace(/^Autor:\s*/, ""),
  //   },
  //   publisher: {
  //     "@type": "Organization",
  //     name: "Agroweb.rs",
  //     logo: {
  //       "@type": "ImageObject",
  //       url: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1750335367/agroweb/logo_fkunfx.png",
  //       width: 870,
  //       height: 359,
  //     },
  //   },
  //   mainEntityOfPage: {
  //     "@type": "WebPage",
  //     "@id": `https://agroweb.rs${window.location.pathname}`,
  //   },
  // };
  // console.log("Struc", structuredData(post));

  return (
    <>
      <Helmet>
        {/* <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> */}
        <script type="application/ld+json">{structuredData(post, dimensions)}</script>
      </Helmet>
      <div className={`singlePost ${id2(pathPart)}`}>
        <div className="banner-wrapper bilbord">
          <AdManagerSlot slotNumber={"div-gpt-ad-1710624971857-0"} />
        </div>
        <div className="content">
          <div className="content-wrapper">
            <main className="mainContent">
              <article className="mainContent-wrapper" itemScope itemType="https://schema.org/Article">
                <span className="mainContent-cat" itemProp="articleSection">
                  {post.category}
                </span>
                <h1 className="mainContent-title" itemProp="headline">
                  {displayTitle}
                </h1>
                <p className="mainContent-lead" itemProp="description">
                  {post.lead}
                </p>
                <div className="time">
                  <span itemProp="publisher" itemScope itemType="https://schema.org/Organization">
                    {setSource(post.source)},{" "}
                  </span>
                  Datum:{" "}
                  <time dateTime={post.modified || post.time2} itemProp="datePublished">
                    {formatTime2(post.modified ? post.modified : post.time2)}
                    {/* <TimeFormat timePost={post.modified ? post.modified : post.time2} /> */}
                  </time>
                </div>
                <figure className="mainContent-img" itemProp="image" itemScope itemType="https://schema.org/ImageObject">
                  {/* <img src={`${post.pics[0]}`} alt={displayTitle} width={dimensions?.width} height={dimensions?.height} itemProp="url" /> */}
                  {/* Check configuration for lazy loading and adopte it on PostImage */}
                  <PostImage src={post.pics[0]} alt={displayTitle} loading="eager" />
                  <meta itemProp="width" content={dimensions?.width?.toString()} />
                  <meta itemProp="height" content={dimensions?.height?.toString()} />
                  <figcaption className="mainContent-img_source">
                    <span>Foto: </span>
                    <span dangerouslySetInnerHTML={{ __html: post.pics[1] }}></span>
                  </figcaption>
                </figure>
                <div className="mainContent-social">
                  <Suspense fallback={<div></div>}>
                    <SocialButtons testImg={post.pics[0]} location={location.pathname} postTitle={displayTitle} />
                  </Suspense>
                </div>
                <div className="mainContent-bodyText" itemProp="articleBody">
                  <BodyText adUnitPath={location.pathname} bodyText={post.body} promoPR={post.promoPR} />
                </div>
                <div className="banner-wrapper">
                  <AdManagerSlot slotNumber={"div-gpt-ad-1711317911230-0"} />
                </div>
                <div className="tags">
                  <span className="tags-title">Tagovi:</span>
                  <div className="tags__arr">
                    {post.tags.map((item, index) => {
                      return (
                        <Link key={index} to={`/tag/${urlTitle2(item)}/`}>
                          {item}
                        </Link>
                      );
                    })}
                  </div>
                </div>

                <StickyAd adUnitPath={location.pathname} />
              </article>
              <Suspense fallback={<div></div>}>
                <aside className="newsAside foot">
                  <AsideBox items={memoAsideBoxes[0]} classes="newsAside foot" dispAds={false} adUnitPath={location.pathname} />
                  <AsideBox items={memoAsideBoxes[1]} classes="newsAside foot" dispAds={false} adUnitPath={location.pathname} />
                </aside>
              </Suspense>
            </main>
            <Suspense fallback={<div></div>}>
              <aside className="newsAside">
                <AsideBox items={memoAsideBoxes[2]} classes="newsAside" dispAds={true} adUnitPath={location.pathname} />
                <div className="banner-wrapper">
                  <AdManagerSlot slotNumber={"div-gpt-ad-1711058573014-0"} />
                </div>
                <AsideBox items={memoAsideBoxes[3]} classes="newsAside" dispAds={true} adUnitPath={location.pathname} />
              </aside>
            </Suspense>
          </div>
          <div className="banner-wrapper">
            <AdManagerSlot slotNumber={"div-gpt-ad-1711282241522-0"} />
          </div>
        </div>
      </div>
    </>
  );
}
